var cilMediaRecord = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M256,72C154.542,72,72,154.542,72,256s82.542,184,184,184,184-82.542,184-184S357.458,72,256,72Zm0,336c-83.813,0-152-68.187-152-152s68.187-152,152-152,152,68.187,152,152S339.813,408,256,408Z' class='ci-primary'/>"];

export { cilMediaRecord };

